var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient, HttpParams, } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';
import { Auth } from '@shared/auth';
import { Observable } from 'rxjs/Observable';
import { catchError, filter, map, switchMap, withLatestFrom, } from 'rxjs/operators';
import { pipe } from 'rxjs/util/pipe';
import { backend, backendSearch, } from './backend';
import { isDefined } from './helpers';
var ApiHttp = /** @class */ (function () {
    function ApiHttp(http, errorHandler, auth, datastoreConfig) {
        this.http = http;
        this.errorHandler = errorHandler;
        this.auth = auth;
        this.datastoreConfig = datastoreConfig;
    }
    ApiHttp.prototype.fetch = function (ref) {
        var _this = this;
        return Observable.of(ref).pipe(switchMap(function (_a) {
            var path = _a.path, query = _a.query;
            return Observable.of(backend[path[0]].fetch).pipe(filter(isDefined), map(function (fetch) { return fetch(path[1], path[2], query); }), _this.fetchHelper(query));
        }));
    };
    ApiHttp.prototype.fetchSearch = function (key, query) {
        return query.pipe(map(function (q) { return backendSearch[key].fetch(q); }), this.fetchHelper(), map(function (response) { return (response.status === 'success' ? response.result : []); }));
    };
    ApiHttp.prototype.fetchHelper = function (query) {
        var _this = this;
        return pipe(withLatestFrom(this.auth.getAuthorizationHeader()), switchMap(function (_a) {
            var config = _a[0], authHeader = _a[1];
            var baseUrl = config.isGaf
                ? _this.datastoreConfig.ajaxBaseUrl
                : _this.datastoreConfig.apiBaseUrl;
            var pagination = {
                limit: query && query.limit,
                offset: query && query.offset,
            };
            // Add webapp=1 for tracking in the backend to API requests
            var configParams = config.isGaf
                ? config.params
                : __assign({}, config.params, { webapp: 1 });
            var params = pagination
                ? __assign({}, configParams, { limit: pagination.limit, offset: pagination.offset }) : configParams;
            return _this.http.get(baseUrl + "/" + config.endpoint, {
                headers: authHeader,
                params: _this.serialize(params),
            });
        }), catchError(function (err) {
            if (err.error instanceof Error) {
                // A client-side or network error occurred.
                _this.errorHandler.handleError(err.error);
                // FIXME: not sure why TS can't figure out the typings here
                return Observable.of({
                    status: 'error',
                    message: err.error.message,
                });
            }
            // The backend returned an unsuccessful response code.
            _this.errorHandler.handleError(new Error(err.message));
            // FIXME: not sure why TS can't figure out the typings here
            return Observable.of({
                status: 'error',
                message: err.message,
            });
        }));
    };
    ApiHttp.prototype.post = function (config, payload) {
        return this.mutate(config, { action: 'post', payload: payload });
    };
    ApiHttp.prototype.put = function (config, payload) {
        return this.mutate(config, { action: 'put', payload: payload });
    };
    ApiHttp.prototype.delete = function (config) {
        return this.mutate(config, { action: 'delete' });
    };
    ApiHttp.prototype.mutate = function (config, data) {
        var _this = this;
        return Observable.of(config).pipe(withLatestFrom(this.auth.getAuthorizationHeader()), switchMap(function (_a) {
            var newConfig = _a[0], authHeader = _a[1];
            var baseUrl = newConfig.isGaf
                ? _this.datastoreConfig.ajaxBaseUrl
                : _this.datastoreConfig.apiBaseUrl;
            var url = baseUrl + "/" + newConfig.endpoint;
            var options = { headers: authHeader };
            if (data.action === 'delete') {
                return _this.http.delete(url, options);
            }
            var body = _this.serialize(__assign({}, data.payload, newConfig.params));
            if (data.action === 'post') {
                return _this.http.post(url, body, options);
            }
            return _this.http.put(url, body, options);
        }));
    };
    ApiHttp.prototype.serialize = function (obj) {
        var params = new HttpParams();
        Object.entries(obj).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (typeof value === 'string') {
                params = params.set(key, value);
            }
            else if (typeof value === 'number') {
                params = params.set(key, String(value));
            }
            else if (Array.isArray(value)) {
                // This type casting shouldn't be necessary but is because of a TS bug.
                // https://github.com/Microsoft/TypeScript/issues/15315
                // https://github.com/Microsoft/TypeScript/issues/7294
                // Our backend expects arrays foo=[1,2] to be encoded as foo[]=1&foo[]=2
                value
                    .filter(isDefined)
                    .forEach(function (rawVal) {
                    // The batching of requests connatenates things with `&`.
                    return String(rawVal)
                        .split('&')
                        .forEach(function (v) { return (params = params.append(key + "[]", v)); });
                });
            }
        });
        params = params.set('compact', 'true');
        return params;
    };
    return ApiHttp;
}());
export { ApiHttp };



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/api-http.service.ts.pre-build-optimizer.js